module.exports = __webpack_public_path__ + "media/images/registrationtop-a9a540f761943f5015a0dce38f6afe27.png";